import { css } from '@emotion/css';
import React from 'react';
import { BackButton } from 'src/components/shared/buttons/BackButton';
import { UserColor } from 'src/models/resort/UserColor';
import { getDecoPatternUrl } from './getDecoPatternUrl';

interface UserColorHeaderProps {
  title: string;
  backLabel?: string;
  userColor?: UserColor;
  decoId?: number;
}

export const UserColorHeader: React.FC<UserColorHeaderProps> = ({
  title,
  backLabel,
  userColor,
  decoId
}) => {
  const decoPattern = userColor ? getDecoPatternUrl(userColor?.deco, decoId) : undefined;
  return (
    <>
      <header
        className={css`
          width: 100%;
          height: 52px;
          position: relative;
          z-index: 10;
          color: ${userColor?.text || '#4d3906'};
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 64px;
            background: ${userColor?.main || 'transparent'};
            background-image: ${decoPattern ? `url('${decoPattern}')` : 'none'};
            clip-path: url(#rs-arch-shape-clip);
            /* iOS Safariでclip-pathが効かなくなる問題に対するworkaround */
            will-change: transform;
          }
          .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            height: 52px;
            padding: 0 4px;
          }
          .title {
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .space {
            width: 48px;
            height: 48px;
          }
        `}
      >
        <div className="header-content">
          {backLabel ? <BackButton ariaLabel={backLabel} /> : <div className="space" />}
          <h1 className="title">{title}</h1>
          <div className="space" />
        </div>
        <svg width="0" height="0">
          <defs>
            <clipPath id="rs-arch-shape-clip" clipPathUnits="objectBoundingBox">
              <path d="M1 0H0V0.75V1H3.43645e-07C0.131414 0.891041 0.307052 0.824475 0.5 0.824475C0.692948 0.824475 0.868586 0.891041 1 1V0.75V0Z" />
            </clipPath>
          </defs>
        </svg>
      </header>
    </>
  );
};
